import { EbPersonalInfoInterface } from '../../common/interfaces/eb-common-form.interface'

export interface EbContactFormCommonInterface {
  topicId: string
  message: string
  attachment: File
  personalInfo: EbPersonalInfoInterface
  captcha: string
}

export interface EbContactFormInterface extends EbContactFormCommonInterface {
  approvalOfDataPolicy: string
}

export interface EbContactFormOccInterface extends EbContactFormCommonInterface {
  approvalOfDataPolicy: boolean
}

export interface EbContactUsTopic {
  id: string
  name: string
}

export enum EbContactFormTokenEnum {
  SHIPPINGADDRESS = 'requestShippingAddress'
}

export type EbContactUsTopics = EbContactUsTopic[]
